var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay && _vm.showRule !== "render"
    ? _c(
        "preview-form-item",
        {
          attrs: {
            labelText: _vm.labelName,
            labelWidth: _vm.labelWidth,
            labelPosition: _vm.labelPosition,
            textAlign: _vm.labelTextPosition,
            formType: _vm.formType,
            rules: _vm.validatorRule,
            variableName: _vm.model,
            paddingLeft: _vm.paddingLeft
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-item_input" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "form-item_upload",
                  class: {
                    "is-limited": _vm.showFileListData.length >= _vm.uploadLimit
                  },
                  attrs: {
                    action: _vm.uploadHost,
                    limit: _vm.uploadLimit,
                    "http-request": _vm.uploadImage,
                    "on-remove": _vm.handleRemove,
                    "on-exceed": _vm.handleExceed,
                    "file-list": _vm.showFileListData
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44b6d5c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b6d5c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemUploadFile.vue
// module id = null
// module chunks = 